/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RatingDtoBase
 * auto generated base class for the model RatingDtoModel.
 */
export const RatingDtoModelBase = ModelBase
  .named('RatingDto')
  .props({
    __typename: types.optional(types.literal("RatingDto"), "RatingDto"),
    visitId: types.union(types.undefined, types.integer),
    rate: types.union(types.undefined, types.number),
    comment: types.union(types.undefined, types.null, types.string),
    createdOn: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RatingDtoModelSelector extends QueryBuilder {
  get visitId() { return this.__attr(`visitId`) }
  get rate() { return this.__attr(`rate`) }
  get comment() { return this.__attr(`comment`) }
  get createdOn() { return this.__attr(`createdOn`) }
}
export function selectFromRatingDto() {
  return new RatingDtoModelSelector()
}

export const ratingDtoModelPrimitives = selectFromRatingDto().visitId.rate.comment.createdOn
